export { default } from "../admin/workspace/[screenId]";
